import { valueStoreFactory } from 'services/utils/valueStoreFactory';

const DEFAULT_TTL_MS = 60_000;

const buildStoreValue = (ttlMs = DEFAULT_TTL_MS) => {
    const map = new Map();

    const addTrace = (traceId, rootName) => {
        if (!traceId || !rootName) {
            return;
        }
        prune();
        map.set(traceId, { rootName, expiresAt: Date.now() + ttlMs });
    };

    const getTraceName = traceId => {
        prune();
        return map.get(traceId)?.rootName ?? null;
    };

    const removeTrace = traceId => {
        prune();
        map.delete(traceId);
    };

    const prune = () => {
        const now = Date.now();
        map.forEach((entry, key) => {
            if (now > entry.expiresAt) {
                map.delete(key);
            }
        });
    };

    return {
        addTrace,
        getTraceName,
        removeTrace,
    };
};

export const traceMapStore = valueStoreFactory();
traceMapStore.setValue(buildStoreValue());
